import React, { useState } from "react";
import { DatePickerInputNew } from "../../../Helpers/Input/Input";
import { useLazyGetHistoryPositionQuery } from "../../../../Redux/service/Positions";
import { useMap } from "react-leaflet";
import { useDispatch } from "react-redux";
import { setHistoryPositions } from "../../../../Redux/service/Websocket";
import { toast } from "react-toastify";
import { toLocalISOString } from "../../../../JsHelpers/DateFormat";
import trans from "../../../../utils";
export default function PlayBackTripDate({
	setStartDate,
	setEndDate,
	startDate,
	endDate,
	vid,
}) {
	let map = useMap();
	let [date, setDate] = useState({ start: startDate, end: endDate });
	const dispatch = useDispatch();
	const handleDateRangeChange = ({ startDate, endDate }) => {
		setStartDate(startDate ? toLocalISOString(new Date(startDate)) : null);
		setEndDate(endDate ? toLocalISOString(new Date(endDate)) : null);
	};
	let [getHistPos] = useLazyGetHistoryPositionQuery();
	const handleFetchData = async () => {
		try {
			if (vid && startDate && endDate) {
				const response = await getHistPos({
					deviceId: vid,
					from: startDate,
					to: endDate,
				});

				if (response?.data.length > 0) {
					dispatch(setHistoryPositions(response.data));
					map.setView(
						[response.data[0]?.latitude, response.data[0]?.longitude],
						22
					);
					setDate({ start: startDate, end: endDate });
				} else if (response?.data.length === 0) {
					toast.error(trans("No data found"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
				} else {
					toast.error(trans("Error fetching data"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
				}
			} else {
				toast.error(trans("Error fetching data"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			}
		} catch (error) {
			toast.error(trans("Error fetching data"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};
	return (
		<div className="history-playback-dateinput  flex-between">
			<div className="flex-between">
				<img
					src={`${process.env.PUBLIC_URL}/assets/DateRange.svg`}
					alt="daterange"
				/>
				<DatePickerInputNew
					id="dateRange"
					name="dateRange"
					onChange={handleDateRangeChange}
					variant="borderless"
					rangeStyle="dateRange"
					startDate={startDate}
					endDate={endDate}
				/>
			</div>

			<div
				className={
					startDate !== date.start || endDate !== date.end
						? "settings"
						: "settings-disabled"
				}
				onClick={
					startDate !== date.start || endDate !== date.end
						? handleFetchData
						: undefined
				}
			>
				{trans("Update")}
			</div>
		</div>
	);
}
